<div class="card">
    <div class="card-header">
        Duplicate Device Punching Details Report -Front
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-3 px-1">
                <label class="Label"> Attendance Date<span class="text-danger">*</span></label>
                <div class="input-group">
                    <input class="form-control" placeholder="yyyy-mm-dd" name="fromdate " placeholder="Ex. DD/MM/YYYY"
                        [(ngModel)]="FromDate" #HolidayDate="ngModel" ngbDatepicker #d="ngbDatepicker"
                        [ngModelOptions]="{standalone: true}" required readonly />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"
                        type="button"></button>
                    <div class="invalid-feedback">
                        Please enter attendance date !
                    </div>
                </div>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-4 px-1">
                <label class="Label">Branch</label>
                <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="BranchId" (change)=" onSelectChange('Branch'); ComboLoad('Client')" placeholder="Select Branch">
                    <ng-option *ngFor="let segment of BranchMaster" [value]="segment.BranchMasterID">
                        {{ segment.BranchName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-8 px-1">
                <label class="Label">Client</label>
                <ng-select name="client" [items]="ClientLoad" bindLabel="ClientGroupName"
                    bindValue="ClientGroupMasterID" [(ngModel)]="ClientId"
                    (change)="onSelectChange('Client'); ComboLoad('Site')" placeholder="Select Client">
                    <ng-option *ngFor="let segment of ClientLoad" [value]="segment.ClientGroupMasterID">
                        {{ segment.ClientGroupName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-8 px-1">
                <label class="Label">Site</label>
                <ng-select name="site" [items]="SiteLoad" bindLabel="SiteName" bindValue="SiteMasterID"
                    [(ngModel)]="SiteId" (change)="onSelectChange('Site');" placeholder="Select Site">
                    <ng-option *ngFor="let segment of SiteLoad" [value]="segment.SiteMasterID">
                        {{ segment.SiteName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-3 px-1">
                <label class="Label">Employee Code</label>
                <input name="empcode"  type="text" placeholder="Enter Employee Code" [(ngModel)]="EmpCode" class="form-control" />
            </div>
            <div class="col-md-2 px-1"><br>
                <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="submit" (click)="Load()">
                    <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Cancel':'Loading...'}}</button>
        </div>
    </div>
</div>